/**
 * Calendly Widget Utilities
 * Handles loading and initialization of Calendly popup widget
 */

export const CALENDLY_URL = 'https://calendly.com/hello-quanturama/30min';

/**
 * Load Calendly CSS and JavaScript
 * Should be called once when component mounts
 */
export const loadCalendlyScripts = () => {
  const linkId = 'calendly-widget-css';
  const scriptId = 'calendly-widget-script';

  // Load CSS
  if (!document.getElementById(linkId)) {
    const link = document.createElement('link');
    link.id = linkId;
    link.rel = 'stylesheet';
    link.href = 'https://assets.calendly.com/assets/external/widget.css';
    document.head.appendChild(link);
  }

  // Load Script
  if (!document.getElementById(scriptId)) {
    const script = document.createElement('script');
    script.id = scriptId;
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.body.appendChild(script);
  }
};

/**
 * Open Calendly popup widget
 */
export const openCalendlyPopup = () => {
  if (window.Calendly) {
    window.Calendly.initPopupWidget({ url: CALENDLY_URL });
  }
};
